const SDK_VERSION = '7.74.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
